import "./styles/App.css";
import "./styles/auth-login-box.css"
import { Navbar, Footer, LoginPanel, Metrics } from "./components/containers"
import { useAuthenticateUserOnComponentMount, useUpdateMetricsOnUserSelection, useShowErrorOnMetricsRequestFailure} from "./hooks/hooks"
/* 
  Rename the alert handler in commons
  -- change showAlertV2 back to its original
*/
function App() {
  useAuthenticateUserOnComponentMount()
  useUpdateMetricsOnUserSelection()
  useShowErrorOnMetricsRequestFailure()
  return (
    <div className="App min-h-screen">
      <Navbar></Navbar>
      <div className="min-h-screen flex flex-col justify-between items-center">
        <LoginPanel></LoginPanel>
        <Metrics></Metrics>
      </div>
      <Footer/>
    </div>
  );
}
export default App;
